import { useRouter } from 'next/router';

export const usePathBreakdown = () => {
  const router = useRouter();
  const path = router.asPath.split('#')[0];
  const [, ...pathBreakdown] = path.split('/');
  return pathBreakdown;
};
